"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequiredFieldsGuard = exports.validateRequiredField = void 0;
const lodash_1 = require("lodash");
const customWorkflowFields_1 = require("../../constants/customWorkflowFields");
function validateRequiredField(field) {
    switch (typeof field) {
        case 'string':
            return field.length > 0;
        case 'number':
            return isFinite(field);
        case 'boolean':
            return true;
        case 'object':
            return Array.isArray(field) ? field.length > 0 : !!field;
    }
    return false;
}
exports.validateRequiredField = validateRequiredField;
// common guard functionality
function RequiredFieldsGuard(taskEntity, params) {
    if (!taskEntity) {
        console.error('No Task Entity found for "require-fields" guard.');
        return false;
    }
    return !!(params === null || params === void 0 ? void 0 : params.requiredFields.every(requiredField => {
        // skip check if custom field (e.g. assignSubTasks)
        if (customWorkflowFields_1.customWorkflowFields.some(field => field.value === requiredField)) {
            return true;
        }
        // field should be valid
        const field = lodash_1.get(taskEntity, requiredField);
        return validateRequiredField(field);
    }));
}
exports.RequiredFieldsGuard = RequiredFieldsGuard;
//# sourceMappingURL=RequiredFieldsPlugin.js.map